// extracted by mini-css-extract-plugin
export const gallery = "galleryComponent-module--gallery--3s_HH";
export const mobileGallery = "galleryComponent-module--mobileGallery--3aT1I";
export const modalContainer = "galleryComponent-module--modalContainer--16CER";
export const slideWrapper = "galleryComponent-module--slideWrapper--2yApt";
export const desktopSliderGallery = "galleryComponent-module--desktopSliderGallery--OjfgB";